import { Button, Grid, Link, useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { logoutUser } from '../../services/login_services';
import { getAllNeededVerifications } from '../../services/report_services';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { PageType, setCurrentPage } from '../../store/slices/general.slice';
import IconMenu from './IconMenu';
import { RoundedButton } from './RoundedButton';
import { Business } from '@mui/icons-material';
import { primaryColor, styles } from '../../assets/styles/styles';

export default function NavBar({
  navigate,
  loggedIn,
  transparent = false,
}: any) {
  const theme = useTheme();
  const [allNeededVerifications, setAllNeededVerifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const dispatch = useAppDispatch();
  const [allNeededVerificationsLoading, setAllNeededVerificationsLoading] =
    useState(false);
  const { admin, currentPage } = useSelector(
    (state: any) => state.GeneralSlice
  );

  useEffect(() => {
    if (admin) {
      getAllNeededVerifications(
        setAllNeededVerifications,
        setAllNeededVerificationsLoading
      );
    }
  }, [admin, currentPage]);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [logo1Height, setLogo1Height] = useState(0);
  const [logo2Height, setLogo2Height] = useState(0);

  // Clamp the height adjustment to keep it sensible
  useEffect(() => {
    const heightAdjustment = Math.min(
      10,
      Math.max(-10, (screenWidth - 1200) / 100)
    );

    setLogo1Height(55 + heightAdjustment);
    setLogo2Height(35 + heightAdjustment);
  }, [screenWidth]);

  return (
    <>
      <ToastContainer />
      <AppBar
        position="sticky"
        style={{
          backgroundColor: !admin && '#cd0438' ? '#cd0438' : 'transparent',
          color: '#fff',
          zIndex: 3,
          boxShadow: 'none',
          position: 'sticky',
          top: 0,
        }}
      >
        <Grid
          sx={{ height: '100%', padding: '10px' }}
          container
          justifyContent={'center'}
          alignItems={'center'}
        >
          {!admin ? (
            <Grid
              item
              container
              xs={12}
              sx={{
                backgroundColor: primaryColor,
              }}
              justifyContent={'center'}
            >
              <a href="/?appTrigger=true">
                <Typography
                  style={{
                    color: 'white',
                    ...styles.pSize,
                    fontWeight: '500',
                    cursor: 'pointer',
                  }}
                  textAlign={'center'}
                >
                  Being alone is boring. Join safe spaces to enjoy outdoor life{' '}
                  <span style={{ fontWeight: 'bold' }}> together: </span>{' '}
                  <span
                    style={{
                      textDecorationLine: 'underline',
                    }}
                  >
                    Get started today
                  </span>
                </Typography>
              </a>
            </Grid>
          ) : (
            <Grid item container xs={5}></Grid>
          )}
          <Grid container item xs={3} justifyContent={'flex-end'}>
            {loggedIn ? (
              <>
                <Grid item>
                  <Button
                    variant={'text'}
                    color={'secondary'}
                    onClick={() => {
                      window.scrollTo(0, 0);
                      navigate('/reports');
                    }}
                    style={
                      currentPage === 'report'
                        ? { borderRadius: 0, borderBottom: '2px solid white' }
                        : { paddingBottom: '2px' }
                    }
                  >
                    Reports
                  </Button>
                  <Button
                    variant={'text'}
                    color={'secondary'}
                    onClick={() => {
                      window.scrollTo(0, 0);
                      navigate('/users');
                    }}
                    style={
                      currentPage === 'users'
                        ? { borderRadius: 0, borderBottom: '2px solid white' }
                        : { paddingBottom: '2px' }
                    }
                  >
                    Members
                  </Button>
                  <Button
                    variant={'text'}
                    color={'secondary'}
                    onClick={() => {
                      window.scrollTo(0, 0);
                      navigate('/verifications');
                    }}
                    style={
                      currentPage === 'verification'
                        ? { borderRadius: 0, borderBottom: '2px solid white' }
                        : { paddingBottom: '2px' }
                    }
                  >
                    Verifications ({allNeededVerifications.length})
                  </Button>
                </Grid>
                <Button
                  onClick={() => {
                    logoutUser(navigate);
                  }}
                  variant={'outlined'}
                  color={'secondary'}
                >
                  Logout
                </Button>
              </>
            ) : (
              <Grid item xs={3}>
                {' '}
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={12}
          sx={{ backgroundColor: 'white', padding: '15px' }}
        >
          <Button
            onClick={() => {
              window.location.href = '/';
            }}
          >
            <Grid item container xs={12} sm={12} alignItems={'center'}>
              <img
                src="/static/red_logo_no_text.png"
                style={{
                  height: logo1Height,
                  width: 'auto',
                  marginRight: '10px',
                }}
              />
              <img
                src="/static/red_logo_text_only.png"
                style={{ height: logo2Height, width: 'auto' }}
              />
            </Grid>
          </Button>
        </Grid>
      </AppBar>
    </>
  );
}
